export const STORE_PAGES_LIST = "STORE_PAGES_LIST";
export const FACEBOOK_SELECTION_CLOSE = "FACEBOOK_SELECTION_CLOSE";
export const FACEBOOK_SELECTION_OPEN = "FACEBOOK_SELECTION_OPEN";
export const ALLOW_PAGE_SELECTION = "ALLOW_PAGE_SELECTION";
export const NO_PAGE_SELECTION = "NO_PAGE_SELECTION";


const initialState = { open: false, pageSelection: true, pagesData: {}, userDetails: {} }

function facebookPagesModalReducer(state = initialState, action) {
  switch (action.type) {
    case STORE_PAGES_LIST: 
      return {
        ...state,
        pagesData: action.pages,
        userDetails: action.userDetails,
        open: true
      }

    case FACEBOOK_SELECTION_CLOSE:
      return {
        ...state,
        open: false
      }

    case FACEBOOK_SELECTION_OPEN:
      return {
        ...state,
        open: true
      }
    case ALLOW_PAGE_SELECTION:
      return {
        ...state,
        pageSelection: true
      }
    case NO_PAGE_SELECTION:
      return {
        ...state,
        pageSelection: false
      }

    default:
      return state;
  }
}


export default facebookPagesModalReducer;